module.exports = __webpack_public_path__ + "img/download-mac-app-btn.ad9a46b8.webp";